// Central translation dictionary for the Coumba Kandji Diamonds website.
// Keep every string here — components read via useT('key').
export const dict = {
  en: {
    nav: {
      theHouse: "The House",
      expertFocus: "Expert Focus",
      process: "Process",
      offering: "Offering",
      trust: "Trust",
      contact: "Contact",
      cta: "Send Inquiry",
    },
    hero: {
      eyebrow: "Ethical Sourcing · African Expertise",
      title1: "Certified Diamonds & Precious Stones,",
      title2: "Sourced with Precision.",
      sub: "Loose natural diamonds and curated precious stones, sourced through trusted networks across Africa.",
      ctaInquiry: "Send Inquiry",
      ctaCollection: "Discover our Offering",
      trust: ["100% Natural Diamonds", "Kimberley Certified", "GIA / IGI Available", "Private & Wholesale"],
      scroll: "Scroll",
    },
    about: {
      index: "01",
      overline: "The House",
      title1: "At the Origin",
      title2: "of Rarity.",
      lead: "Coumba Kandji Diamonds specializes in private sourcing and trade of certified loose precious stones — selected for origin, rarity, brilliance and long-term value.",
      body: "Our network reaches deep into Africa and major international markets, granting access to white and fancy color diamonds, rubies, tanzanite, alexandrite, and other rare precious stones. Every inquiry is handled with discretion, professionalism, and a clear focus on quality.",
      stats: [
        { value: "100%", label: "Natural Diamonds Only" },
        { value: "Africa", label: "Trusted Sourcing Networks" },
        { value: "Private", label: "Discreet Client Advisory" },
        { value: "Certified", label: "Kimberley · GIA · HRD" },
      ],
    },
    diamonds: {
      index: "02",
      overline: "Expert Focus",
      title1: "Loose Diamonds,",
      title2: "Privately Sourced.",
      body1: "We specialize exclusively in certified natural diamonds — individually selected, documented, and presented for private clients, jewelers, and trade partners.",
      body2: "From classic white to rare fancy colors, every request is handled with absolute discretion and an uncompromising commitment to quality.",
      cards: [
        { title: "White Diamonds", body: "Certified natural white diamonds selected for brilliance, clarity and timeless value." },
        { title: "Fancy Diamonds", body: "Rare natural diamonds in distinctive colors, sourced for clients seeking exceptional and unique pieces." },
        { title: "Private Requests", body: "Tailored sourcing for clients looking for a specific cut, carat, color, clarity or certification." },
        { title: "Wholesale Supply", body: "Curated diamonds and precious stones for jewelers, dealers and wholesale partners." },
      ],
    },
    sourcing: {
      index: "03",
      overline: "The Process",
      title1: "From Trusted Source",
      title2: "to Certified Selection.",
      body: "Every stone begins with a request, a sourcing network and a careful selection process. We review each diamond or gemstone according to its natural origin, quality, documentation and suitability for the client.",
      rotateHint: "Move cursor to rotate",
      stages: [
        { num: "I", label: "Sourcing", detail: "Natural diamonds and precious stones are sourced through trusted African and international networks." },
        { num: "II", label: "Selection", detail: "Each stone is reviewed for quality, rarity, proportions, visual character and client requirements." },
        { num: "III", label: "Certification", detail: "Kimberley certification and recognized gemological documentation such as GIA / HRD are provided where applicable." },
        { num: "IV", label: "Private Presentation", detail: "Selected stones are presented through private consultation with discretion and professional care." },
      ],
    },
    stones: {
      index: "04",
      overline: "Offering",
      title1: "Rare Precious Stones & Diamonds,",
      title2: "Selected for Exceptional Value.",
      body1: "From certified natural diamonds to rare fancy colors, Coumba Kandji sources exceptional precious stones for private collectors, jewelers, and wholesale partners.",
      body2: "While our primary focus is on loose stones, bespoke jewelry design is available upon request once your gem is selected.",
      inquire: "Inquire",
      cards: [
        { top: "NATURAL · CERTIFIED", title: "Natural Diamonds" },
        { top: "FANCY COLOR · RARE", title: "Fancy Color Diamonds" },
        { top: "PRECIOUS STONES · CURATED", title: "Colored Precious Stones" },
        { top: "BESPOKE · UPON REQUEST", title: "Bespoke Creation" },
      ],
    },
    certification: {
      index: "05",
      overline: "Trust & Documentation",
      title1: "Documented Provenance,",
      title2: "Verified Quality.",
      body: "Every diamond and precious stone we present carries recognized documentation — Kimberley certification, GIA or HRD grading reports where applicable, and clear origin information. Nothing left to trust alone.",
      highlights: [
        "Kimberley-certified natural diamonds",
        "GIA / HRD documentation where applicable",
        "Natural origin focus",
        "Private and professional handling",
        "Transparent stone specifications",
      ],
    },
    why: {
      index: "06",
      overline: "Why Coumba Kandji",
      title1: "Seven reasons clients",
      title2: "buy again and again.",
      promise: "The Promise",
      promiseText: "Natural diamonds, sourced with integrity, presented with discretion — without compromise.",
      cta: "Begin a private consultation",
      points: [
        { title: "100% Natural Diamonds", body: "No lab-grown, no compromise. Every stone we trade is Earth-formed, traceable and selected for long-term value." },
        { title: "Certified Provenance", body: "Kimberley-certified diamonds with GIA / HRD documentation where applicable — paperwork our clients can rely on." },
        { title: "Direct African Sourcing", body: "Trusted networks at origin across Africa, paired with international partners — fewer intermediaries, sharper pricing." },
        { title: "Rare Stones, On Request", body: "Access to colored diamonds, fancy yellows, rubies, tanzanite and rare finds most dealers cannot reach." },
        { title: "Private & Wholesale", body: "We serve collectors, jewelers and trade partners equally — with terms calibrated to each relationship." },
        { title: "Discretion as Standard", body: "Every inquiry is handled confidentially. Your sourcing, your specifications and your decisions stay yours." },
        { title: "Personal Advisory", body: "One direct point of contact from first inquiry to private presentation — no call centers, no handoffs." },
      ],
    },
    inquiry: {
      index: "07",
      overline: "Private Inquiry",
      title1: "Request a Private",
      title2: "Diamond Consultation.",
      body1: "For natural diamonds, precious stones, wholesale sourcing or private requests, please send us your inquiry. Each request is reviewed personally and handled with discretion.",
      body2: "Tell us what you are looking for — including stone type, carat range, preferred certification, budget range or sourcing purpose. We will review your request and respond with the next steps.",
      directContact: "Direct Contact",
      headquarters: "Headquarters",
      addressL1: "Keur Serigne Koki, HLM Cité Millionnaire",
      addressL2: "25000 Rufisque · Dakar · Senegal",
      labelName: "Name *",
      labelEmail: "Email *",
      labelPhone: "Phone / WhatsApp",
      labelType: "Inquiry Type *",
      labelMessage: "Message *",
      placeholderName: "Your full name",
      placeholderEmail: "you@domain.com",
      placeholderPhone: "+221 ...",
      placeholderMessage: "Describe the stone, project or consultation you have in mind...",
      privacyNote: "By sending this inquiry, you agree to our privacy policy. Your information is handled with absolute discretion.",
      submit: "Send Inquiry",
      sending: "Sending inquiry…",
      confirmed: "Confirmed",
      successMsg: "Inquiry sent successfully.",
      errorTitle: "Unable to send",
      errValidName: "Please enter your name.",
      errValidEmail: "Please enter a valid email address.",
      errValidMessage: "Please include a short message.",
      errGeneric: "Something went wrong while sending your inquiry. Please try again or contact us directly at info@coumbakandji.com.",
      types: [
        "Diamond Inquiry",
        "Precious Stone Inquiry",
        "Private Consultation",
        "Jewelry / Custom Request",
        "Other",
      ],
    },
    footer: {
      tagline: "A specialist in certified natural diamonds and precious stones — sourced at origin through trusted African networks for private and wholesale clients.",
      contact: "Contact",
      directInquiries: "Direct Inquiries",
      phone: "Phone",
      internationalLabel: "International",
      senegalLabel: "Senegal",
      headquarters: "Headquarters",
      navigate: "Navigate",
      follow: "Follow",
      privateInquiry: "Private Inquiry",
      allRights: "All rights reserved",
      legal: "Legal Notice",
      privacy: "Privacy Policy",
    },
    whatsapp: {
      label: "WhatsApp",
      question: "How can we help you?",
      close: "Close",
      aria: "Chat with Coumba Kandji Diamonds on WhatsApp",
    },
    legal: {
      backHome: "Back to Home",
      overline: "Legal · Imprint",
      title1: "Legal Notice",
      title2: "& Imprint.",
      lead: "Information required by applicable trade and media regulations. This page is provided by Coumba Kandji Diamonds and applies to all content published on coumbakandji.com.",
      lastUpdated: "Last updated",
      returnLabel: "Return to Coumba Kandji Diamonds",
    },
    privacy: {
      backHome: "Back to Home",
      overline: "Privacy · Data Protection",
      title1: "Privacy Policy",
      title2: "& Data Protection.",
      lead: "Coumba Kandji Diamonds treats every inquiry with absolute discretion. This policy explains what personal data we collect, why we collect it, how we protect it, and the rights you have as a visitor or client.",
      lastUpdated: "Last updated",
      returnLabel: "Return to Coumba Kandji Diamonds",
    },
    gone: {
      overline: "410 · No Longer Available",
      title1: "This page has",
      title2: "been retired.",
      body: "The page you are looking for is no longer part of Coumba Kandji Diamonds. It has been intentionally removed and will not return at this address.",
      ctaHome: "Return to the Homepage",
      ctaLegal: "Legal Notice",
    },
    lang: {
      label: "Language",
      english: "English",
      french: "Français",
    },
  },

  fr: {
    nav: {
      theHouse: "La Maison",
      expertFocus: "Expertise",
      process: "Processus",
      offering: "Sélection",
      trust: "Confiance",
      contact: "Contact",
      cta: "Envoyer Demande",
    },
    hero: {
      eyebrow: "Sourcing Éthique · Expertise Africaine",
      title1: "Diamants & Pierres Précieuses Certifiés,",
      title2: "Sélectionnés avec Précision.",
      sub: "Diamants naturels non montés et pierres précieuses d'exception, sourcés à travers des réseaux de confiance sur le continent africain.",
      ctaInquiry: "Envoyer Demande",
      ctaCollection: "Découvrir Notre Sélection",
      trust: ["100% Diamants Naturels", "Certifiés Kimberley", "GIA / IGI Disponibles", "Privé & Gros"],
      scroll: "Défiler",
    },
    about: {
      index: "01",
      overline: "La Maison",
      title1: "À l'Origine",
      title2: "de la Rareté.",
      lead: "Coumba Kandji Diamonds est spécialisée dans le sourcing privé et le négoce de pierres précieuses certifiées non montées — sélectionnées pour leur origine, leur rareté, leur brillance et leur valeur à long terme.",
      body: "Notre réseau s'étend au cœur de l'Afrique et sur les principaux marchés internationaux, offrant l'accès à des diamants blancs et de couleur, rubis, tanzanite, alexandrite et autres pierres précieuses rares. Chaque demande est traitée avec discrétion, professionnalisme et une exigence claire de qualité.",
      stats: [
        { value: "100%", label: "Diamants Naturels Uniquement" },
        { value: "Afrique", label: "Réseaux de Sourcing de Confiance" },
        { value: "Privé", label: "Conseil Client Discret" },
        { value: "Certifié", label: "Kimberley · GIA · HRD" },
      ],
    },
    diamonds: {
      index: "02",
      overline: "Expertise",
      title1: "Diamants Non Montés,",
      title2: "Sourcing Privé.",
      body1: "Nous nous spécialisons exclusivement dans les diamants naturels certifiés — sélectionnés individuellement, documentés et présentés aux clients privés, joailliers et partenaires commerciaux.",
      body2: "Du blanc classique aux rares couleurs fantaisie, chaque demande est traitée avec une discrétion absolue et un engagement sans compromis envers la qualité.",
      cards: [
        { title: "Diamants Blancs", body: "Diamants blancs naturels certifiés, sélectionnés pour leur éclat, leur pureté et leur valeur intemporelle." },
        { title: "Diamants de Couleur", body: "Diamants naturels rares aux couleurs distinctives, sourcés pour les clients en quête de pièces exceptionnelles et uniques." },
        { title: "Demandes Privées", body: "Sourcing sur mesure pour les clients recherchant une taille, un carat, une couleur, une pureté ou une certification spécifique." },
        { title: "Approvisionnement en Gros", body: "Sélection de diamants et pierres précieuses pour joailliers, négociants et partenaires grossistes." },
      ],
    },
    sourcing: {
      index: "03",
      overline: "Le Processus",
      title1: "De la Source de Confiance",
      title2: "à la Sélection Certifiée.",
      body: "Chaque pierre commence par une demande, un réseau de sourcing et un processus de sélection minutieux. Nous examinons chaque diamant ou gemme selon son origine naturelle, sa qualité, sa documentation et son adéquation au client.",
      rotateHint: "Bougez le curseur pour tourner",
      stages: [
        { num: "I", label: "Sourcing", detail: "Les diamants naturels et pierres précieuses sont sourcés via des réseaux africains et internationaux de confiance." },
        { num: "II", label: "Sélection", detail: "Chaque pierre est évaluée pour sa qualité, sa rareté, ses proportions, son caractère visuel et les exigences du client." },
        { num: "III", label: "Certification", detail: "La certification Kimberley et les documentations gemmologiques reconnues telles que GIA / HRD sont fournies lorsque disponibles." },
        { num: "IV", label: "Présentation Privée", detail: "Les pierres sélectionnées sont présentées en consultation privée avec discrétion et professionnalisme." },
      ],
    },
    stones: {
      index: "04",
      overline: "Sélection",
      title1: "Pierres Précieuses & Diamants Rares,",
      title2: "Sélectionnés pour une Valeur Exceptionnelle.",
      body1: "Des diamants naturels certifiés aux rares couleurs fantaisie, Coumba Kandji sélectionne des pierres précieuses exceptionnelles pour collectionneurs privés, joailliers et partenaires grossistes.",
      body2: "Bien que notre priorité soit les pierres non montées, la création de joaillerie sur mesure est disponible sur demande une fois votre pierre choisie.",
      inquire: "Demander",
      cards: [
        { top: "NATUREL · CERTIFIÉ", title: "Diamants Naturels" },
        { top: "COULEUR FANTAISIE · RARE", title: "Diamants de Couleur" },
        { top: "PIERRES PRÉCIEUSES · CURATÉES", title: "Pierres Précieuses de Couleur" },
        { top: "SUR MESURE · SUR DEMANDE", title: "Création Sur Mesure" },
      ],
    },
    certification: {
      index: "05",
      overline: "Confiance & Documentation",
      title1: "Provenance Documentée,",
      title2: "Qualité Vérifiée.",
      body: "Chaque diamant et pierre précieuse que nous présentons porte une documentation reconnue — certification Kimberley, rapports de classification GIA ou HRD lorsque disponibles, et informations claires sur l'origine. Rien n'est laissé à la confiance seule.",
      highlights: [
        "Diamants naturels certifiés Kimberley",
        "Documentation GIA / HRD lorsque disponible",
        "Priorité à l'origine naturelle",
        "Gestion privée et professionnelle",
        "Spécifications transparentes des pierres",
      ],
    },
    why: {
      index: "06",
      overline: "Pourquoi Coumba Kandji",
      title1: "Sept raisons pour lesquelles",
      title2: "nos clients reviennent.",
      promise: "La Promesse",
      promiseText: "Diamants naturels, sourcés avec intégrité, présentés avec discrétion — sans compromis.",
      cta: "Commencer une consultation privée",
      points: [
        { title: "100% Diamants Naturels", body: "Aucun de laboratoire, aucun compromis. Chaque pierre est formée par la Terre, traçable et sélectionnée pour sa valeur à long terme." },
        { title: "Provenance Certifiée", body: "Diamants certifiés Kimberley avec documentation GIA / HRD lorsque disponible — une traçabilité fiable pour nos clients." },
        { title: "Sourcing Africain Direct", body: "Réseaux de confiance à l'origine à travers l'Afrique, associés à des partenaires internationaux — moins d'intermédiaires, meilleurs prix." },
        { title: "Pierres Rares, Sur Demande", body: "Accès à des diamants de couleur, jaunes fantaisie, rubis, tanzanite et raretés que peu de négociants peuvent atteindre." },
        { title: "Privé & Gros", body: "Nous servons collectionneurs, joailliers et partenaires professionnels avec des conditions adaptées à chaque relation." },
        { title: "La Discrétion en Standard", body: "Chaque demande est traitée en toute confidentialité. Votre sourcing, vos spécifications et vos décisions vous appartiennent." },
        { title: "Conseil Personnel", body: "Un point de contact direct de la première demande à la présentation privée — sans centres d'appel ni transferts." },
      ],
    },
    inquiry: {
      index: "07",
      overline: "Demande Privée",
      title1: "Demander une Consultation",
      title2: "Diamant Privée.",
      body1: "Pour des diamants naturels, pierres précieuses, sourcing en gros ou demandes privées, envoyez-nous votre demande. Chaque requête est examinée personnellement et traitée avec discrétion.",
      body2: "Dites-nous ce que vous recherchez — type de pierre, gamme de carats, certification préférée, budget ou objectif de sourcing. Nous étudierons votre demande et vous répondrons avec les prochaines étapes.",
      directContact: "Contact Direct",
      headquarters: "Siège",
      addressL1: "Keur Serigne Koki, HLM Cité Millionnaire",
      addressL2: "25000 Rufisque · Dakar · Sénégal",
      labelName: "Nom *",
      labelEmail: "E-mail *",
      labelPhone: "Téléphone / WhatsApp",
      labelType: "Type de Demande *",
      labelMessage: "Message *",
      placeholderName: "Votre nom complet",
      placeholderEmail: "vous@domaine.com",
      placeholderPhone: "+221 ...",
      placeholderMessage: "Décrivez la pierre, le projet ou la consultation que vous envisagez...",
      privacyNote: "En envoyant cette demande, vous acceptez notre politique de confidentialité. Vos informations sont traitées avec la plus grande discrétion.",
      submit: "Envoyer Demande",
      sending: "Envoi en cours…",
      confirmed: "Confirmé",
      successMsg: "Demande envoyée avec succès.",
      errorTitle: "Envoi impossible",
      errValidName: "Veuillez saisir votre nom.",
      errValidEmail: "Veuillez saisir une adresse e-mail valide.",
      errValidMessage: "Veuillez inclure un court message.",
      errGeneric: "Une erreur est survenue lors de l'envoi. Réessayez ou contactez-nous directement à info@coumbakandji.com.",
      types: [
        "Demande Diamant",
        "Demande Pierre Précieuse",
        "Consultation Privée",
        "Joaillerie / Sur Mesure",
        "Autre",
      ],
    },
    footer: {
      tagline: "Spécialiste en diamants naturels certifiés et pierres précieuses — sourcés à l'origine à travers des réseaux africains de confiance pour clients privés et grossistes.",
      contact: "Contact",
      directInquiries: "Demandes Directes",
      phone: "Téléphone",
      internationalLabel: "International",
      senegalLabel: "Sénégal",
      headquarters: "Siège",
      navigate: "Naviguer",
      follow: "Suivre",
      privateInquiry: "Demande Privée",
      allRights: "Tous droits réservés",
      legal: "Mentions Légales",
      privacy: "Politique de Confidentialité",
    },
    whatsapp: {
      label: "WhatsApp",
      question: "Comment pouvons-nous vous aider ?",
      close: "Fermer",
      aria: "Discuter avec Coumba Kandji Diamonds sur WhatsApp",
    },
    legal: {
      backHome: "Retour à l'Accueil",
      overline: "Légal · Mentions",
      title1: "Mentions Légales",
      title2: "& Imprimé.",
      lead: "Informations requises par la réglementation applicable en matière commerciale et médiatique. Cette page est fournie par Coumba Kandji Diamonds et s'applique à l'ensemble du contenu publié sur coumbakandji.com.",
      lastUpdated: "Dernière mise à jour",
      returnLabel: "Retour à Coumba Kandji Diamonds",
    },
    privacy: {
      backHome: "Retour à l'Accueil",
      overline: "Confidentialité · Protection des Données",
      title1: "Politique de Confidentialité",
      title2: "& Protection des Données.",
      lead: "Coumba Kandji Diamonds traite chaque demande avec la plus grande discrétion. Cette politique explique quelles données personnelles nous collectons, pourquoi, comment nous les protégeons et les droits dont vous disposez.",
      lastUpdated: "Dernière mise à jour",
      returnLabel: "Retour à Coumba Kandji Diamonds",
    },
    gone: {
      overline: "410 · N'est Plus Disponible",
      title1: "Cette page a",
      title2: "été retirée.",
      body: "La page que vous recherchez ne fait plus partie de Coumba Kandji Diamonds. Elle a été volontairement retirée et ne reviendra pas à cette adresse.",
      ctaHome: "Retour à l'Accueil",
      ctaLegal: "Mentions Légales",
    },
    lang: {
      label: "Langue",
      english: "English",
      french: "Français",
      spanish: "Español",
      russian: "Русский",
    },
  },

  es: {
    nav: {
      theHouse: "La Casa",
      expertFocus: "Especialidad",
      process: "Proceso",
      offering: "Oferta",
      trust: "Confianza",
      contact: "Contacto",
      cta: "Enviar Solicitud",
    },
    hero: {
      eyebrow: "Aprovisionamiento Ético · Experiencia Africana",
      title1: "Diamantes y Piedras Preciosas Certificados,",
      title2: "Seleccionados con Precisión.",
      sub: "Diamantes naturales sueltos y piedras preciosas selectas, aprovisionados a través de redes de confianza en toda África.",
      ctaInquiry: "Enviar Solicitud",
      ctaCollection: "Descubrir Nuestra Oferta",
      trust: ["100% Diamantes Naturales", "Certificados Kimberley", "GIA / IGI Disponibles", "Privado y Mayorista"],
      scroll: "Desplazar",
    },
    about: {
      index: "01",
      overline: "La Casa",
      title1: "En el Origen",
      title2: "de la Rareza.",
      lead: "Coumba Kandji Diamonds se especializa en el aprovisionamiento privado y comercio de piedras preciosas certificadas sueltas — seleccionadas por su origen, rareza, brillo y valor a largo plazo.",
      body: "Nuestra red se extiende por África y los principales mercados internacionales, otorgando acceso a diamantes blancos y de color, rubíes, tanzanita, alejandrita y otras piedras preciosas raras. Cada solicitud se gestiona con discreción, profesionalidad y un enfoque claro en la calidad.",
      stats: [
        { value: "100%", label: "Solo Diamantes Naturales" },
        { value: "África", label: "Redes de Aprovisionamiento Confiables" },
        { value: "Privado", label: "Asesoría Discreta al Cliente" },
        { value: "Certificado", label: "Kimberley · GIA · HRD" },
      ],
    },
    diamonds: {
      index: "02",
      overline: "Especialidad",
      title1: "Diamantes Sueltos,",
      title2: "Aprovisionamiento Privado.",
      body1: "Nos especializamos exclusivamente en diamantes naturales certificados — seleccionados individualmente, documentados y presentados a clientes privados, joyeros y socios comerciales.",
      body2: "Desde el blanco clásico hasta los raros colores fantasía, cada solicitud se gestiona con absoluta discreción y un compromiso incomparable con la calidad.",
      cards: [
        { title: "Diamantes Blancos", body: "Diamantes blancos naturales certificados, seleccionados por su brillo, pureza y valor atemporal." },
        { title: "Diamantes de Color", body: "Diamantes naturales raros de colores distintivos, aprovisionados para clientes que buscan piezas excepcionales y únicas." },
        { title: "Solicitudes Privadas", body: "Aprovisionamiento a medida para clientes que buscan un talle, quilate, color, pureza o certificación específicos." },
        { title: "Suministro Mayorista", body: "Diamantes y piedras preciosas seleccionados para joyeros, comerciantes y socios mayoristas." },
      ],
    },
    sourcing: {
      index: "03",
      overline: "El Proceso",
      title1: "De la Fuente Confiable",
      title2: "a la Selección Certificada.",
      body: "Cada piedra comienza con una solicitud, una red de aprovisionamiento y un proceso de selección minucioso. Revisamos cada diamante o gema según su origen natural, calidad, documentación e idoneidad para el cliente.",
      rotateHint: "Mueva el cursor para girar",
      stages: [
        { num: "I", label: "Aprovisionamiento", detail: "Los diamantes naturales y piedras preciosas se aprovisionan a través de redes africanas e internacionales de confianza." },
        { num: "II", label: "Selección", detail: "Cada piedra se evalúa por su calidad, rareza, proporciones, carácter visual y requerimientos del cliente." },
        { num: "III", label: "Certificación", detail: "Se proporciona la certificación Kimberley y documentación gemológica reconocida como GIA / HRD cuando corresponde." },
        { num: "IV", label: "Presentación Privada", detail: "Las piedras seleccionadas se presentan en consulta privada con discreción y cuidado profesional." },
      ],
    },
    stones: {
      index: "04",
      overline: "Oferta",
      title1: "Piedras Preciosas y Diamantes Raros,",
      title2: "Seleccionados por su Valor Excepcional.",
      body1: "Desde diamantes naturales certificados hasta raros colores fantasía, Coumba Kandji selecciona piedras preciosas excepcionales para coleccionistas privados, joyeros y socios mayoristas.",
      body2: "Aunque nuestro enfoque principal son las piedras sueltas, el diseño de joyería a medida está disponible bajo pedido una vez seleccionada su piedra.",
      inquire: "Consultar",
      cards: [
        { top: "NATURAL · CERTIFICADO", title: "Diamantes Naturales" },
        { top: "COLOR FANTASÍA · RARO", title: "Diamantes de Color" },
        { top: "PIEDRAS PRECIOSAS · CURADAS", title: "Piedras Preciosas de Color" },
        { top: "A MEDIDA · BAJO PEDIDO", title: "Creación a Medida" },
      ],
    },
    certification: {
      index: "05",
      overline: "Confianza y Documentación",
      title1: "Procedencia Documentada,",
      title2: "Calidad Verificada.",
      body: "Cada diamante y piedra preciosa que presentamos lleva documentación reconocida — certificación Kimberley, informes de clasificación GIA o HRD cuando corresponde, e información clara sobre el origen. Nada se deja a la confianza sola.",
      highlights: [
        "Diamantes naturales certificados Kimberley",
        "Documentación GIA / HRD cuando corresponde",
        "Enfoque en el origen natural",
        "Gestión privada y profesional",
        "Especificaciones transparentes de las piedras",
      ],
    },
    why: {
      index: "06",
      overline: "Por Qué Coumba Kandji",
      title1: "Siete razones por las que",
      title2: "los clientes vuelven una y otra vez.",
      promise: "La Promesa",
      promiseText: "Diamantes naturales, aprovisionados con integridad, presentados con discreción — sin compromisos.",
      cta: "Iniciar una consulta privada",
      points: [
        { title: "100% Diamantes Naturales", body: "Sin cultivos de laboratorio, sin concesiones. Cada piedra es formada por la Tierra, trazable y seleccionada por su valor a largo plazo." },
        { title: "Procedencia Certificada", body: "Diamantes certificados Kimberley con documentación GIA / HRD cuando corresponde — trazabilidad confiable para nuestros clientes." },
        { title: "Aprovisionamiento Africano Directo", body: "Redes de confianza en el origen a través de África, combinadas con socios internacionales — menos intermediarios, mejores precios." },
        { title: "Piedras Raras, Bajo Pedido", body: "Acceso a diamantes de color, amarillos fantasía, rubíes, tanzanita y rarezas que pocos comerciantes pueden alcanzar." },
        { title: "Privado y Mayorista", body: "Atendemos a coleccionistas, joyeros y socios comerciales con condiciones adaptadas a cada relación." },
        { title: "Discreción como Estándar", body: "Cada solicitud se trata con confidencialidad. Su aprovisionamiento, sus especificaciones y sus decisiones son suyas." },
        { title: "Asesoría Personal", body: "Un punto de contacto directo desde la primera solicitud hasta la presentación privada — sin centros de llamadas ni traspasos." },
      ],
    },
    inquiry: {
      index: "07",
      overline: "Solicitud Privada",
      title1: "Solicitar una Consulta",
      title2: "de Diamantes Privada.",
      body1: "Para diamantes naturales, piedras preciosas, aprovisionamiento mayorista o solicitudes privadas, envíenos su consulta. Cada solicitud se revisa personalmente y se gestiona con discreción.",
      body2: "Díganos qué está buscando — tipo de piedra, rango de quilates, certificación preferida, presupuesto u objetivo de aprovisionamiento. Revisaremos su solicitud y responderemos con los próximos pasos.",
      directContact: "Contacto Directo",
      headquarters: "Sede Central",
      addressL1: "Keur Serigne Koki, HLM Cité Millionnaire",
      addressL2: "25000 Rufisque · Dakar · Senegal",
      labelName: "Nombre *",
      labelEmail: "Correo electrónico *",
      labelPhone: "Teléfono / WhatsApp",
      labelType: "Tipo de Solicitud *",
      labelMessage: "Mensaje *",
      placeholderName: "Su nombre completo",
      placeholderEmail: "usted@dominio.com",
      placeholderPhone: "+221 ...",
      placeholderMessage: "Describa la piedra, proyecto o consulta que tiene en mente...",
      privacyNote: "Al enviar esta solicitud, acepta nuestra política de privacidad. Su información se maneja con absoluta discreción.",
      submit: "Enviar Solicitud",
      sending: "Enviando solicitud…",
      confirmed: "Confirmado",
      successMsg: "Solicitud enviada con éxito.",
      errorTitle: "No se pudo enviar",
      errValidName: "Por favor, ingrese su nombre.",
      errValidEmail: "Por favor, ingrese una dirección de correo válida.",
      errValidMessage: "Por favor, incluya un breve mensaje.",
      errGeneric: "Ocurrió un error al enviar su solicitud. Inténtelo de nuevo o contáctenos directamente en info@coumbakandji.com.",
      types: [
        "Consulta Diamante",
        "Consulta Piedra Preciosa",
        "Consulta Privada",
        "Joyería / A Medida",
        "Otro",
      ],
    },
    footer: {
      tagline: "Especialista en diamantes naturales certificados y piedras preciosas — aprovisionados en el origen a través de redes africanas de confianza para clientes privados y mayoristas.",
      contact: "Contacto",
      directInquiries: "Consultas Directas",
      phone: "Teléfono",
      internationalLabel: "Internacional",
      senegalLabel: "Senegal",
      headquarters: "Sede",
      navigate: "Navegar",
      follow: "Seguir",
      privateInquiry: "Solicitud Privada",
      allRights: "Todos los derechos reservados",
      legal: "Aviso Legal",
      privacy: "Política de Privacidad",
    },
    whatsapp: {
      label: "WhatsApp",
      question: "¿Cómo podemos ayudarle?",
      close: "Cerrar",
      aria: "Chatear con Coumba Kandji Diamonds en WhatsApp",
    },
    legal: {
      backHome: "Volver al Inicio",
      overline: "Legal · Aviso",
      title1: "Aviso Legal",
      title2: "e Impresión.",
      lead: "Información requerida por la normativa comercial y de medios aplicable. Esta página es proporcionada por Coumba Kandji Diamonds y se aplica a todo el contenido publicado en coumbakandji.com.",
      lastUpdated: "Última actualización",
      returnLabel: "Volver a Coumba Kandji Diamonds",
    },
    privacy: {
      backHome: "Volver al Inicio",
      overline: "Privacidad · Protección de Datos",
      title1: "Política de Privacidad",
      title2: "y Protección de Datos.",
      lead: "Coumba Kandji Diamonds trata cada solicitud con absoluta discreción. Esta política explica qué datos personales recopilamos, por qué los recopilamos, cómo los protegemos y los derechos que usted tiene como visitante o cliente.",
      lastUpdated: "Última actualización",
      returnLabel: "Volver a Coumba Kandji Diamonds",
    },
    gone: {
      overline: "410 · Ya No Disponible",
      title1: "Esta página ha",
      title2: "sido retirada.",
      body: "La página que busca ya no forma parte de Coumba Kandji Diamonds. Ha sido retirada intencionalmente y no regresará a esta dirección.",
      ctaHome: "Volver al Inicio",
      ctaLegal: "Aviso Legal",
    },
    lang: {
      label: "Idioma",
      english: "English",
      french: "Français",
      spanish: "Español",
      russian: "Русский",
    },
  },

  ru: {
    nav: {
      theHouse: "Дом",
      expertFocus: "Специализация",
      process: "Процесс",
      offering: "Коллекция",
      trust: "Доверие",
      contact: "Контакты",
      cta: "Отправить Запрос",
    },
    hero: {
      eyebrow: "Этичные Поставки · Африканская Экспертиза",
      title1: "Сертифицированные Бриллианты и Драгоценные Камни,",
      title2: "Отобранные с Точностью.",
      sub: "Природные бриллианты россыпью и отобранные драгоценные камни, поставляемые через проверенные сети по всей Африке.",
      ctaInquiry: "Отправить Запрос",
      ctaCollection: "Открыть Нашу Коллекцию",
      trust: ["100% Природные Бриллианты", "Сертификат Кимберли", "GIA / IGI Доступны", "Частные и Оптовые"],
      scroll: "Прокрутить",
    },
    about: {
      index: "01",
      overline: "Дом",
      title1: "У Истоков",
      title2: "Редкости.",
      lead: "Coumba Kandji Diamonds специализируется на частных поставках и торговле сертифицированными драгоценными камнями россыпью — отобранными за их происхождение, редкость, блеск и долгосрочную ценность.",
      body: "Наша сеть охватывает глубины Африки и основные международные рынки, обеспечивая доступ к белым и цветным бриллиантам, рубинам, танзаниту, александриту и другим редким драгоценным камням. Каждый запрос обрабатывается с осмотрительностью, профессионализмом и чётким акцентом на качестве.",
      stats: [
        { value: "100%", label: "Только Природные Бриллианты" },
        { value: "Африка", label: "Надёжные Сети Поставок" },
        { value: "Частное", label: "Конфиденциальное Обслуживание" },
        { value: "Сертифицировано", label: "Кимберли · GIA · HRD" },
      ],
    },
    diamonds: {
      index: "02",
      overline: "Специализация",
      title1: "Бриллианты Россыпью,",
      title2: "Частные Поставки.",
      body1: "Мы специализируемся исключительно на сертифицированных природных бриллиантах — индивидуально отобранных, документированных и представленных частным клиентам, ювелирам и торговым партнёрам.",
      body2: "От классических белых до редких фантазийных цветов, каждый запрос обрабатывается с абсолютной осмотрительностью и бескомпромиссной приверженностью качеству.",
      cards: [
        { title: "Белые Бриллианты", body: "Сертифицированные природные белые бриллианты, отобранные за их блеск, чистоту и вневременную ценность." },
        { title: "Цветные Бриллианты", body: "Редкие природные бриллианты уникальных цветов, поставляемые клиентам, ищущим исключительные и уникальные экземпляры." },
        { title: "Частные Запросы", body: "Индивидуальные поставки для клиентов, ищущих определённую огранку, каратность, цвет, чистоту или сертификат." },
        { title: "Оптовые Поставки", body: "Отобранные бриллианты и драгоценные камни для ювелиров, дилеров и оптовых партнёров." },
      ],
    },
    sourcing: {
      index: "03",
      overline: "Процесс",
      title1: "От Проверенного Источника",
      title2: "к Сертифицированному Отбору.",
      body: "Каждый камень начинается с запроса, сети поставок и тщательного процесса отбора. Мы оцениваем каждый бриллиант или драгоценный камень по его природному происхождению, качеству, документации и соответствию клиенту.",
      rotateHint: "Двигайте курсор для вращения",
      stages: [
        { num: "I", label: "Поставка", detail: "Природные бриллианты и драгоценные камни поставляются через проверенные африканские и международные сети." },
        { num: "II", label: "Отбор", detail: "Каждый камень оценивается по качеству, редкости, пропорциям, визуальному характеру и требованиям клиента." },
        { num: "III", label: "Сертификация", detail: "Сертификация Кимберли и признанная геммологическая документация, такая как GIA / HRD, предоставляются, когда это применимо." },
        { num: "IV", label: "Частная Презентация", detail: "Отобранные камни представляются в рамках частной консультации с осмотрительностью и профессиональным вниманием." },
      ],
    },
    stones: {
      index: "04",
      overline: "Коллекция",
      title1: "Редкие Драгоценные Камни и Бриллианты,",
      title2: "Отобранные за Исключительную Ценность.",
      body1: "От сертифицированных природных бриллиантов до редких фантазийных цветов, Coumba Kandji отбирает исключительные драгоценные камни для частных коллекционеров, ювелиров и оптовых партнёров.",
      body2: "Хотя наш основной фокус — камни россыпью, индивидуальный дизайн ювелирных изделий доступен по запросу после выбора камня.",
      inquire: "Запросить",
      cards: [
        { top: "ПРИРОДНЫЕ · СЕРТИФИЦИРОВАННЫЕ", title: "Природные Бриллианты" },
        { top: "ФАНТАЗИЙНЫЙ ЦВЕТ · РЕДКИЕ", title: "Цветные Бриллианты" },
        { top: "ДРАГОЦЕННЫЕ КАМНИ · ОТОБРАННЫЕ", title: "Цветные Драгоценные Камни" },
        { top: "ИНДИВИДУАЛЬНО · ПО ЗАПРОСУ", title: "Индивидуальное Изделие" },
      ],
    },
    certification: {
      index: "05",
      overline: "Доверие и Документация",
      title1: "Документированное Происхождение,",
      title2: "Подтверждённое Качество.",
      body: "Каждый бриллиант и драгоценный камень, который мы представляем, имеет признанную документацию — сертификацию Кимберли, отчёты о классификации GIA или HRD, когда это применимо, и чёткую информацию о происхождении. Ничего не оставлено на веру.",
      highlights: [
        "Природные бриллианты, сертифицированные по Кимберли",
        "Документация GIA / HRD, когда применимо",
        "Фокус на природном происхождении",
        "Частное и профессиональное обращение",
        "Прозрачные характеристики камней",
      ],
    },
    why: {
      index: "06",
      overline: "Почему Coumba Kandji",
      title1: "Семь причин, по которым",
      title2: "клиенты возвращаются снова.",
      promise: "Обещание",
      promiseText: "Природные бриллианты, поставляемые с честностью, представляемые с осмотрительностью — без компромиссов.",
      cta: "Начать частную консультацию",
      points: [
        { title: "100% Природные Бриллианты", body: "Никаких лабораторных, никаких компромиссов. Каждый камень образован Землёй, отслеживаем и отобран за его долгосрочную ценность." },
        { title: "Сертифицированное Происхождение", body: "Бриллианты с сертификатом Кимберли и документацией GIA / HRD, когда это применимо — надёжная прослеживаемость для наших клиентов." },
        { title: "Прямые Африканские Поставки", body: "Проверенные сети у источника по всей Африке в сочетании с международными партнёрами — меньше посредников, лучшие цены." },
        { title: "Редкие Камни по Запросу", body: "Доступ к цветным бриллиантам, фантазийным жёлтым, рубинам, танзаниту и редким находкам, недоступным большинству дилеров." },
        { title: "Частные и Оптовые", body: "Мы обслуживаем коллекционеров, ювелиров и торговых партнёров с условиями, адаптированными к каждым отношениям." },
        { title: "Осмотрительность как Стандарт", body: "Каждый запрос обрабатывается конфиденциально. Ваши поставки, спецификации и решения остаются вашими." },
        { title: "Личное Консультирование", body: "Один прямой контакт от первого запроса до частной презентации — без колл-центров и передач." },
      ],
    },
    inquiry: {
      index: "07",
      overline: "Частный Запрос",
      title1: "Запросить Частную",
      title2: "Бриллиантовую Консультацию.",
      body1: "Для природных бриллиантов, драгоценных камней, оптовых поставок или частных запросов, пожалуйста, отправьте нам ваш запрос. Каждый запрос рассматривается лично и обрабатывается с осмотрительностью.",
      body2: "Расскажите нам, что вы ищете — тип камня, диапазон каратов, предпочтительная сертификация, бюджет или цель поставки. Мы рассмотрим ваш запрос и ответим со следующими шагами.",
      directContact: "Прямой Контакт",
      headquarters: "Штаб-квартира",
      addressL1: "Keur Serigne Koki, HLM Cité Millionnaire",
      addressL2: "25000 Rufisque · Дакар · Сенегал",
      labelName: "Имя *",
      labelEmail: "Электронная почта *",
      labelPhone: "Телефон / WhatsApp",
      labelType: "Тип Запроса *",
      labelMessage: "Сообщение *",
      placeholderName: "Ваше полное имя",
      placeholderEmail: "вы@домен.com",
      placeholderPhone: "+221 ...",
      placeholderMessage: "Опишите камень, проект или консультацию, которую вы имеете в виду...",
      privacyNote: "Отправляя этот запрос, вы соглашаетесь с нашей политикой конфиденциальности. Ваша информация обрабатывается с абсолютной осмотрительностью.",
      submit: "Отправить Запрос",
      sending: "Отправка запроса…",
      confirmed: "Подтверждено",
      successMsg: "Запрос успешно отправлен.",
      errorTitle: "Не удалось отправить",
      errValidName: "Пожалуйста, введите ваше имя.",
      errValidEmail: "Пожалуйста, введите действительный адрес электронной почты.",
      errValidMessage: "Пожалуйста, включите краткое сообщение.",
      errGeneric: "Что-то пошло не так при отправке запроса. Пожалуйста, попробуйте снова или свяжитесь с нами напрямую по info@coumbakandji.com.",
      types: [
        "Запрос по Бриллианту",
        "Запрос по Драгоценному Камню",
        "Частная Консультация",
        "Ювелирное Изделие / Индивидуально",
        "Другое",
      ],
    },
    footer: {
      tagline: "Специалист по сертифицированным природным бриллиантам и драгоценным камням — поставляемым из источника через проверенные африканские сети для частных и оптовых клиентов.",
      contact: "Контакты",
      directInquiries: "Прямые Запросы",
      phone: "Телефон",
      internationalLabel: "Международный",
      senegalLabel: "Сенегал",
      headquarters: "Штаб-квартира",
      navigate: "Навигация",
      follow: "Подписаться",
      privateInquiry: "Частный Запрос",
      allRights: "Все права защищены",
      legal: "Правовая Информация",
      privacy: "Политика Конфиденциальности",
    },
    whatsapp: {
      label: "WhatsApp",
      question: "Чем мы можем помочь?",
      close: "Закрыть",
      aria: "Написать в Coumba Kandji Diamonds через WhatsApp",
    },
    legal: {
      backHome: "Вернуться на Главную",
      overline: "Правовая · Информация",
      title1: "Правовая Информация",
      title2: "и Импринт.",
      lead: "Информация, требуемая применимыми торговыми и медийными нормами. Эта страница предоставлена Coumba Kandji Diamonds и применяется ко всему контенту, опубликованному на coumbakandji.com.",
      lastUpdated: "Последнее обновление",
      returnLabel: "Вернуться в Coumba Kandji Diamonds",
    },
    privacy: {
      backHome: "Вернуться на Главную",
      overline: "Конфиденциальность · Защита Данных",
      title1: "Политика Конфиденциальности",
      title2: "и Защита Данных.",
      lead: "Coumba Kandji Diamonds обрабатывает каждый запрос с абсолютной осмотрительностью. Эта политика объясняет, какие персональные данные мы собираем, зачем, как мы их защищаем и какие права у вас есть как у посетителя или клиента.",
      lastUpdated: "Последнее обновление",
      returnLabel: "Вернуться в Coumba Kandji Diamonds",
    },
    gone: {
      overline: "410 · Больше Не Доступно",
      title1: "Эта страница",
      title2: "была удалена.",
      body: "Страница, которую вы ищете, больше не является частью Coumba Kandji Diamonds. Она была намеренно удалена и не вернётся по этому адресу.",
      ctaHome: "Вернуться на Главную",
      ctaLegal: "Правовая Информация",
    },
    lang: {
      label: "Язык",
      english: "English",
      french: "Français",
      spanish: "Español",
      russian: "Русский",
    },
  },
};
